<!--活动表单-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            {{ form.id ? form.name + "--------" + "id：" + form.id : "添加活动" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="8vw" class="pb-6" label-position="top">
                <el-form-item label="活动名称" :rules="[{ required: true }]">
                    <el-input v-model="form.name" autocomplete="off" style="width: 100%">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="活动结束时间">
                    <el-tooltip class="item" effect="dark" content="不填则长期有效" placement="top">
                        <el-date-picker
                            v-model="form.end_time"
                            type="date"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="timestamp"
                            placeholder="选择日期时间"
                            style="width: 100%"
                        ></el-date-picker>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="类型" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in typeText"
                        :key="index"
                        v-model="form.type"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
                <el-form-item label="平台" v-if="role === 0" :rules="[{ required: true }]">
					<select-platform
						@choose="choosePlatformId"
					    :selectPlatform="form.platform_id"
					    :width="'100%'"
					/>
                </el-form-item>
				<el-form-item label="优惠券" :rules="[{ required: true }]">
                    <el-select
                        v-model="form.int_param2"
                        clearable
                        placeholder="请选择"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in coupons"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="领取优惠卷张数" :rules="[{ required: true }]">
                    <el-input-number
                        v-model="form.int_param1"
                        controls-position="right"
                        :min="1"
                    ></el-input-number>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { mapState } from "vuex";
import util from "@/util";
import store from "@/store";
import SelectPlatform from "@/components/SelectPlatform";
export default {
    name: "ActivityForm",
	components: {
		SelectPlatform
	},
    data() {
        return {
            form: {
                id: null,
                name: null,
                end_time: Date.parse(new Date()), //结束时间戳 可以为空
                int_param1: null, //领取优惠卷张数
                int_param2: null, //优惠卷ID
                type: null, //类型 0：优惠券
				platform_id: null, //平台
            },
            typeText: [
                {
                    id: 0,
                    value: "优惠券",
                },
            ],
            coupons: [],
        };
    },
    props: {
        isAdd: Boolean,
        isEdit: Boolean,
        activityInfo: null,
    },
    created() {
        this.getCoupon();
        if (this.activityInfo) {
            this.form = Object.assign({}, this.activityInfo);
            this.form["end_time"] = this.form["end_time"] * 1000;
        }
		if(this.role === 1) {
			this.form["platform_id"] = this.platform_id;
		}
    },
    computed: {
        ...mapState(["theme", "couponInfos","role","platform_id"]),
    },
    methods: {
        /*获取优惠券*/
        async getCoupon() {
            let params = {
                postData: {},
                callback: () => {
                    this.loading = false;
                },
            };
            await store.dispatch("getCoupon", params);
            let datas = this.JsonData(this.couponInfos);
            let arr = [];
            for (let i = 0; i < datas.length; i++) {
                arr[i] = {
                    value: datas[i].id,
                    label: datas[i].name,
                };
            }
            this.coupons = this.JsonData(arr);
        },
        /*选择平台*/
		choosePlatformId(e) {
			// console.log(e)
			this.form.platform_id = e
		},
		/*确定*/
        determine() {
            let params = {
                postData: {},
                callback: () => {
                    this.$emit("refresh");
                    this.cancel();
                },
            };
            let form = Object.assign({}, this.form);
            if (this.form["type"] == 0) {
                delete form["type"];
            }
			form["platform_id"] = Number(form["platform_id"])
			if(this.role === 0 && !form["platform_id"]) {
				util.ShowTip("请选择平台", 3);
				return;
			}
            if (!form["name"] || !form["int_param1"] || !form["int_param2"]) {
                util.ShowTip("必填项不能为空", 3);
                return;
            }
            form["end_time"] = form["end_time"] / 1000 + 86399;
            params.postData = Object.assign({}, form);
            if (!form["type"]) {
                params.postData["type"] = 0;
            }
			console.log(params.postData)
            if (this.isAdd) {
                delete params.postData["id"];
                store.dispatch("addActivity", params);
            } else if (this.isEdit) {
                store.dispatch("updateActivity", params);
            }
        },
        /*取消*/
        cancel() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = null;
            });
            this.$emit("cancel");
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
